import apiClient from './client'
import type {
  GroupPaymentSettings,
  EffectivePaymentSettings,
  Payment,
  PaymentStatusResponse,
  CreateGroupPaymentSettingsRequest,
  RecordPaymentRequest,
} from '@/types/payment'

export const paymentsApi = {
  // === Настройки оплаты группы ===

  // POST /api/v1/groups/{groupId}/payment-settings
  createGroupSettings: async (groupId: string, data: CreateGroupPaymentSettingsRequest): Promise<GroupPaymentSettings> => {
    const response = await apiClient.post<GroupPaymentSettings>(`/groups/${groupId}/payment-settings`, data)
    return response.data
  },

  // GET /api/v1/groups/{groupId}/payment-settings
  getGroupSettings: async (groupId: string): Promise<GroupPaymentSettings> => {
    const response = await apiClient.get<GroupPaymentSettings>(`/groups/${groupId}/payment-settings`)
    return response.data
  },

  // PUT /api/v1/groups/{groupId}/payment-settings
  updateGroupSettings: async (groupId: string, data: CreateGroupPaymentSettingsRequest): Promise<GroupPaymentSettings> => {
    const response = await apiClient.put<GroupPaymentSettings>(`/groups/${groupId}/payment-settings`, data)
    return response.data
  },

  // DELETE /api/v1/groups/{groupId}/payment-settings
  deleteGroupSettings: async (groupId: string): Promise<void> => {
    await apiClient.delete(`/groups/${groupId}/payment-settings`)
  },

  // === Статусы оплат в группе ===

  // GET /api/v1/groups/{groupId}/payment-statuses
  getGroupPaymentStatuses: async (groupId: string): Promise<PaymentStatusResponse[]> => {
    const response = await apiClient.get<PaymentStatusResponse[]>(`/groups/${groupId}/payment-statuses`)
    return response.data
  },

  // === Платежи спортсмена ===

  // GET /api/v1/athletes/{athleteId}/payments
  getAthletePayments: async (athleteId: string): Promise<Payment[]> => {
    const response = await apiClient.get<Payment[]>(`/athletes/${athleteId}/payments`)
    return response.data
  },

  // POST /api/v1/athletes/{athleteId}/payments
  recordPayment: async (athleteId: string, data: RecordPaymentRequest): Promise<Payment> => {
    const response = await apiClient.post<Payment>(`/athletes/${athleteId}/payments`, data)
    return response.data
  },

  // GET /api/v1/athletes/{athleteId}/payments/status
  getPaymentStatus: async (athleteId: string): Promise<PaymentStatusResponse> => {
    const response = await apiClient.get<PaymentStatusResponse>(`/athletes/${athleteId}/payments/status`)
    return response.data
  },

  // GET /api/v1/athletes/{athleteId}/payments/settings
  getEffectiveSettings: async (athleteId: string): Promise<EffectivePaymentSettings> => {
    const response = await apiClient.get<EffectivePaymentSettings>(`/athletes/${athleteId}/payments/settings`)
    return response.data
  },

  // === Управление платежами ===

  // DELETE /api/v1/payments/{paymentId}
  deletePayment: async (paymentId: string): Promise<void> => {
    await apiClient.delete(`/payments/${paymentId}`)
  },
}
